
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import Icon from "@/components/UI/Icon.vue";
import { configStore } from "@/store/store";

@Component({
  components: { Icon, TextInput }
})
export default class SearchInput extends Vue {
  @Prop()
  value: unknown;

  @Prop()
  placeholder!: string;

  @Prop()
  autofocus!: boolean;

  @Prop()
  wide!: boolean;

  @Prop()
  small!: boolean;

  edit(newVal: string | null) {
    this.$emit("input", newVal);
  }

  clear() {
    this.$emit("input", "");
  }

  get builderMode() {
    return configStore.builderMode;
  }
}
